// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.white-background{
    background-color: white;
}
:host {
    font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
}
.light-grey-background {
    background-color: rgb(234, 231, 231);
  }
.search-form {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.delegation-table {
    width: 100%;
    border-collapse: collapse;
}

.delegation-table th, .delegation-table td {
    border: 1px solid #ddd;
    padding: 8px;
}

.delegation-table th {
    background-color: #f4f4f4;
}

/* Style for the table container */
.example-container {
    overflow: auto;
    width:100%;
    border:2px solid  #286090;
    border-radius:10px;
    margin:2% 0%;
}
.select-text
{
    color:white;
    background-color: #286090;
    text-align: left;
    padding-left:1%;
}
/* Style for the table */
table {
    width: 100%;
    border-collapse: collapse;
    table-layout: auto; /* Ensures columns adjust to content */
}

/* Style for table headers */
th {
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}

/* Style for table cells */
td {
    border: 1px solid #ddd;
    padding: 8px;
}

/* Style for input fields in headers */
th input {
    width: 100%;
    box-sizing: border-box;
    padding: 4px;
    margin-top: 4px;
}

/* Style for action links */
a {
    color: #007bff;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

/* For spinner */
.spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh; /* Adjust this as needed */
}

mat-spinner {
    margin: auto;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.center-content {
    margin: auto !important;
    text-align: center;
}

.searchFilter {
    display: grid;
    padding-bottom: 10px;
}

.red-icon {
    color: red;
}

/* Adjust column widths */
.mat-column-startDate,
.mat-column-endDate,
.mat-column-dueTo,
.mat-column-toName,
.mat-column-from_Name,
.mat-column-createdBy,
.mat-column-created,
.mat-column-modify,
.mat-column-action {
    flex: 1 1 auto;
    min-width: 150px; /* Ensure minimum width */
}

.material-table-scrollbar {
    overflow: visible;
    height: auto;
  }

  .custom-dialog-container {
    margin: 0 auto;
    left: 0;
    right: 0;
  }

  .sub-container{
    width:100%;
    border:2px solid gray;
    /* background-color: rgb(234, 228, 228); */
    border-radius:10px;
    margin:0%;
    padding-left: 2%;
    padding-right: 2%;
    padding: 2%;
  }
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/admin/modifytempararydoa/modifytempararydoa.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;AACA;IACI,wEAAwE;AAC5E;AACA;IACI,oCAAoC;EACtC;AACF;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,cAAc;IACd,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;AACA;;IAEI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;AACA,wBAAwB;AACxB;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB,EAAE,sCAAsC;AAC9D;;AAEA,4BAA4B;AAC5B;IACI,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa,EAAE,0BAA0B;AAC7C;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA,yBAAyB;AACzB;;;;;;;;;IASI,cAAc;IACd,gBAAgB,EAAE,yBAAyB;AAC/C;;AAEA;IACI,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,qBAAqB;IACrB,0CAA0C;IAC1C,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;AACF,g5KAAg5K","sourcesContent":[".white-background{\n    background-color: white;\n}\n:host {\n    font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n}\n.light-grey-background {\n    background-color: rgb(234, 231, 231);\n  }\n.search-form {\n    display: flex;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.delegation-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.delegation-table th, .delegation-table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n}\n\n.delegation-table th {\n    background-color: #f4f4f4;\n}\n\n/* Style for the table container */\n.example-container {\n    overflow: auto;\n    width:100%;\n    border:2px solid  #286090;\n    border-radius:10px;\n    margin:2% 0%;\n}\n.select-text\n{\n    color:white;\n    background-color: #286090;\n    text-align: left;\n    padding-left:1%;\n}\n/* Style for the table */\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: auto; /* Ensures columns adjust to content */\n}\n\n/* Style for table headers */\nth {\n    background-color: #f2f2f2;\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: left;\n}\n\n/* Style for table cells */\ntd {\n    border: 1px solid #ddd;\n    padding: 8px;\n}\n\n/* Style for input fields in headers */\nth input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 4px;\n    margin-top: 4px;\n}\n\n/* Style for action links */\na {\n    color: #007bff;\n    text-decoration: none;\n}\n\na:hover {\n    text-decoration: underline;\n}\n\n/* For spinner */\n.spinner-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh; /* Adjust this as needed */\n}\n\nmat-spinner {\n    margin: auto;\n    position: absolute;\n    top: 70%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.center-content {\n    margin: auto !important;\n    text-align: center;\n}\n\n.searchFilter {\n    display: grid;\n    padding-bottom: 10px;\n}\n\n.red-icon {\n    color: red;\n}\n\n/* Adjust column widths */\n.mat-column-startDate,\n.mat-column-endDate,\n.mat-column-dueTo,\n.mat-column-toName,\n.mat-column-from_Name,\n.mat-column-createdBy,\n.mat-column-created,\n.mat-column-modify,\n.mat-column-action {\n    flex: 1 1 auto;\n    min-width: 150px; /* Ensure minimum width */\n}\n\n.material-table-scrollbar {\n    overflow: visible;\n    height: auto;\n  }\n\n  .custom-dialog-container {\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n  }\n\n  .sub-container{\n    width:100%;\n    border:2px solid gray;\n    /* background-color: rgb(234, 228, 228); */\n    border-radius:10px;\n    margin:0%;\n    padding-left: 2%;\n    padding-right: 2%;\n    padding: 2%;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
